import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ColleagueReaderForm from '../forms/colleague-reader-form';
import { colleagueReaderValidationSchema } from '../schema/colleagueReader.js';

export default function ColleagueReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Colleague Reader Node Details',
        altText: 'Colleague Reader Node',
        defaultLabel: 'Colleague Reader Node',
      }}
    >
      <CommonNode
        FormComponent={ColleagueReaderForm}
        schemaResolver={colleagueReaderValidationSchema}
      />
    </NodeProvider>
  );
}
